import React, { useState, useEffect } from 'react';
import styles from './ChangePassword.module.scss';
import { useDispatch, useSelector } from 'react-redux';
import { changePassword, clearChangePassword } from '../../../../../store/actions/auth';
import NumericKeyboard from '../../../VirtualKeyboard/NumericKeyboard';
import ModalIcon from '../../Icon/Icon';
import Title from '../../Title/Title';
import Input from '../../Input/Input';
import CloseButton from '../../CloseButton/CloseButton';
import { getTranslation } from '../../../../../utils/translation';
import Feedback from '../Feedback/Feedback';
import Button from '../../Button/Button';
import ErrorMessage from '../../ErrorMessage/ErrorMessage';

const ChangePassword = props => {
    const [input, setInput] = useState({
        oldPassword: {
            showKeyboard: false,
            value: '',
        },
        newPassword: {
            showKeyboard: false,
            value: '',
        },
        confirmPassword: {
            showKeyboard: false,
            value: '',
        },
    });
    const [formValid, setFormValid] = useState(false);
    const dispatch = useDispatch();
    const changePasswordResult = useSelector(state => state.auth.changePassword);

    useEffect(() => {
        return () => dispatch(clearChangePassword());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        const { oldPassword, newPassword, confirmPassword } = input;
        if (
            oldPassword.value !== '' &&
            newPassword.value !== '' &&
            confirmPassword.value !== '' &&
            newPassword.value === confirmPassword.value
        ) {
            setFormValid(true);
        } else {
            setFormValid(false);
        }
    }, [input]);

    const showVirtualKeyboard = inputType => {
        const inputState = { ...input };
        for (let key in input) {
            if (key !== inputType) {
                inputState[key]['showKeyboard'] = false;
            } else {
                inputState[key]['showKeyboard'] = !inputState[key]['showKeyboard'];
            }
        }
        setInput(inputState);
    };

    const closeShowedKeyboard = inputType => {
        setInput({
            ...input,
            [inputType]: { ...input[inputType], showKeyboard: false },
        });
    };

    const onChangeKeyboardValue = (value, { inputType }) => {
        setInput({
            ...input,
            [inputType]: { ...input[inputType], value, showKeyboard: false },
        });
    };

    const submitHandler = () => {
        const newPasswordValue = input.newPassword.value.trim();
        const oldPasswordValue = input.oldPassword.value.trim();

        if (formValid) {
            const dataToSubmit = {
                newPassword: newPasswordValue,
                oldPassword: oldPasswordValue,
            };
            dispatch(changePassword(dataToSubmit));
        }
    };

    return (
        <>
            {changePasswordResult.successMessage ? (
                <Feedback
                    icon={'success'}
                    onClose={props.closeModal}
                    title={getTranslation('changePasswordModalSuccessMessage')}
                    buttonText={'OK'}
                />
            ) : (
                <>
                    {input.oldPassword.showKeyboard && (
                        <NumericKeyboard
                            setInputValue={value =>
                                onChangeKeyboardValue(value, { inputType: 'oldPassword' })
                            }
                            close={() => closeShowedKeyboard('oldPassword')}
                            style={{ bottom: '0', right: '-170px' }}
                        />
                    )}
                    {input.newPassword.showKeyboard && (
                        <NumericKeyboard
                            setInputValue={value =>
                                onChangeKeyboardValue(value, { inputType: 'newPassword' })
                            }
                            close={() => closeShowedKeyboard('newPassword')}
                            style={{ bottom: '0', right: '-170px' }}
                        />
                    )}
                    {input.confirmPassword.showKeyboard && (
                        <NumericKeyboard
                            setInputValue={value =>
                                onChangeKeyboardValue(value, { inputType: 'confirmPassword' })
                            }
                            close={() => closeShowedKeyboard('confirmPassword')}
                            style={{ bottom: '0', right: '-170px' }}
                        />
                    )}
                    <CloseButton onClick={() => props.closeModal()} />
                    <ModalIcon iconKey='password' />
                    <Title>{getTranslation('changePasswordModalTitle')}</Title>
                    <form onSubmit={e => e.preventDefault()}>
                        <Input
                            inputType='password'
                            placeholder={getTranslation('changePasswordModalOldPassPlaceholder')}
                            marginTop='40px'
                            value={input.oldPassword.value}
                            onChange={event =>
                                setInput({
                                    ...input,
                                    oldPassword: {
                                        ...input.oldPassword,
                                        value: event.target.value,
                                    },
                                })
                            }
                            showVirtualKeyboard={() => showVirtualKeyboard('oldPassword')}
                        />
                        <Input
                            inputType='password'
                            placeholder={getTranslation('changePasswordModalNewPassPlaceholder')}
                            marginTop='10px'
                            value={input.newPassword.value}
                            onChange={event =>
                                setInput({
                                    ...input,
                                    newPassword: {
                                        ...input.newPassword,
                                        value: event.target.value,
                                    },
                                })
                            }
                            showVirtualKeyboard={() => showVirtualKeyboard('newPassword')}
                        />
                        <Input
                            inputType='password'
                            placeholder={getTranslation(
                                'changePasswordModalConfirmNewPassPlaceholder'
                            )}
                            marginTop='10px'
                            value={input.confirmPassword.value}
                            onChange={event =>
                                setInput({
                                    ...input,
                                    confirmPassword: {
                                        ...input.confirmPassword,
                                        value: event.target.value,
                                    },
                                })
                            }
                            showVirtualKeyboard={() => showVirtualKeyboard('confirmPassword')}
                        />
                        <div className={styles.buttonGroup}>
                            <Button
                                type='submit'
                                disabled={!formValid || changePasswordResult.loading}
                                onClick={() => submitHandler()}
                                width='183px'
                                marginRight={'15px'}
                                title={
                                    changePasswordResult.loading
                                        ? getTranslation('common.actions.loading')
                                        : getTranslation('changePasswordModalChangeButton')
                                }
                            />
                            <Button
                                secondary
                                onClick={() => props.closeModal()}
                                width='102px'
                                title={getTranslation('common.actions.cancel')}
                            />
                        </div>
                    </form>

                    {changePasswordResult.error && (
                        <ErrorMessage>{changePasswordResult.error.reason}</ErrorMessage>
                    )}
                </>
            )}
        </>
    );
};

export default ChangePassword;
